<input [attr.guide]="'zip-import-inp-1' + '__' + sanitizedUrl" type="file" #myInput ng2FileSelect [uploader]="uploader"/>
<div fxLayout="row" class="padding-10" fxLayoutAlign="start center" fxLayoutGap="5px">

    <ng-container  *ngIf="uploader?.queue?.length>0">
        <button [attr.guide]="'zip-import-btn-2' + '__' + sanitizedUrl" [disabled]="text !='Upload'" (click)="upload()"
        mat-raised-button>
        {{text}}
        <mat-icon *ngIf="text !='Upload' ">
            <mat-spinner color="primary" diameter="20">
            </mat-spinner>
        </mat-icon>
    </button>
    </ng-container>
  
</div>
